import { render, staticRenderFns } from "./subSuccess.vue?vue&type=template&id=455af9d0&scoped=true&"
import script from "./subSuccess.vue?vue&type=script&lang=js&"
export * from "./subSuccess.vue?vue&type=script&lang=js&"
import style0 from "./subSuccess.vue?vue&type=style&index=0&id=455af9d0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455af9d0",
  null
  
)

export default component.exports